const container = "container mx-auto px-6 py-8 space-y-6";

const icon = "w-5 h-5";

const label = "font-medium";

const alertWarning = "bg-warning/10 border border-warning/20 rounded-lg p-4 mt-6";
const alertText = "text-sm text-warning";

const inlineIcon = "h-4 w-4 inline mr-1.5 text-muted-foreground";

const alertIcon = "h-4 w-4 inline mr-1.5";

export { container, icon, label, alertWarning, alertText, inlineIcon, alertIcon };
